'use strict';

import { THEME_TYPES } from "@infoods/lifebase-ui";
import { getLoginRequiredResolveObj } from "../shared/utils/angularUtils";

export const scanIqCustomerManagementModule = angular
  .module('app.scanIqCustomerManagement', [])
  .config(scanIqCustomerManagementConfig);

scanIqCustomerManagementConfig.$inject = ['$routeProvider'];

function scanIqCustomerManagementConfig($routeProvider) {
  $routeProvider
    .when('/inbody-scaniq', {
      template: '<ngz-in-body-scan-iq></ngz-in-body-scan-iq>',
      pageConfig: {
        theme: THEME_TYPES.INBODY,
        hideHeader: true,
        hideFooter: true,
      },
    })
    .when('/customers-dashboard/scan-iq', {
      template: '<ngz-customers-dashboard-scan-iq></ngz-customers-dashboard-scan-iq>',
      resolve: getLoginRequiredResolveObj(),
    })
    .when('/customer-profile/scan-iq/:entityId/:customerId', {
      reloadOnSearch: false,
      template: '<ngz-scan-iq-customer-profile></ngz-scan-iq-customer-profile>',
      resolve: getLoginRequiredResolveObj(),
    });
}
